import ApplicationAdapter from '../application';

export default class Group extends ApplicationAdapter {
  namespace = 'schools/v4';
  modelNamePlural = 'optionGroups';

  pathForType(type) {
    type = type.replace(/^school-options\/group/, 'schema/optiongroups');
    return type;
  }
}
